import { last } from 'ramda';

export const getSetClassName = (template = '') => {
  const templateString = last(template.split('/'));
  if (!templateString) return template;

  return `set-${templateString.replace('-set.ftl', '')}`;
};
